export default __webpack_public_path__ + "static/media/certificate_7.a3db6700.jpeg";